export enum ManifestStatus {
    InProgress = 'InProgress',
    Completed = 'Completed',
    InError = 'InError',
    Cancelled = 'Cancelled',
    Uploaded = 'Uploaded',
}
